
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/post2pet",
      function () {
        return require("private-next-pages/services/post2pet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/post2pet"])
      });
    }
  